module.exports = __webpack_public_path__ + "img/turkie.591dd78f.jpeg";